import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import ValidatedTextField from './ValidatedTextField';

const CurrencyInput = ({
  name, label, control, watch, rules,
}) => {
  const value = watch(name);
  return (
    <ValidatedTextField
      name={name}
      control={control}
      rules={{
        pattern: {
          value: /^([0-9])*(\.\d{1,2})?$/g,
          message: 'Must be a positive dollar value without commas.',
        },
        min: {
          value: 0.01,
          message: 'Must be greater than zero.',
        },
        ...rules,
      }}
    >
      <TextField
        fullWidth
        inputMode="numeric"
        label={label}
        InputProps={{ startAdornment: value && <InputAdornment position="start">$</InputAdornment> }}
      />
    </ValidatedTextField>
  );
};

export default CurrencyInput;
